import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import routes from './routes'

Vue.use(Router)

const router = new Router({ routes, linkActiveClass: 'is-active', mode: 'history' })
// const router = new Router({ routes, linkActiveClass: 'is-active' })

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$options.auth.isLoggedIn) {
      if (to.name === 'logout') {
        store.dispatch('logout')
        return next({ path: '/login' })
      }
    } else {
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }

    if (to.meta && to.meta.auth) {
      const auth = to.meta.auth

      router.app.$options.auth.isAuthorized(auth.model, auth.permission)
        .then(() => {
          // if (router.app.$options.auth.isCust() && !router.app.$options.auth.currentUser.fiscal_data_verified) {
          //   console.log('NEXTT', router.app.$options.auth.currentUser)
          //   return next({ path: '/verify' })
          // } else {
          //   next()
          // }
          next()
        })
        .catch(() => {
          if (to.name === 'home') {
            store.dispatch('logout')
            return next({ path: '/login' })
          } else {
            next(auth.redirectTo || { name: 'home', query: { redirect: to.path } })
          }
        })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
